import { httpGet, httpPost, httpPatchMerge, httpDelete } from '../http'
import type { TEntityId } from '~/types/models'
import type { ICaseType } from '~/types/case/models'

const apiEntityPath = '/api/casetypes'

export async function getCaseTypes() {
  const callingMn = getCaseTypes.name
  const apiPath = `${apiEntityPath}`
  return httpGet<ICaseType[]>({ callingMn, apiPath })
}

export async function createCaseType(entity: ICaseType) {
  const callingMn = createCaseType.name
  const apiPath = apiEntityPath
  return httpPost<ICaseType>({ callingMn, apiPath, entity })
}

export async function updateCaseType(
  entityData: Partial<ICaseType>,
  id: TEntityId
) {
  const callingMn = updateCaseType.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialCaseType = Partial<ICaseType>
  return httpPatchMerge<TPartialCaseType>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteCaseType(entityData: ICaseType) {
  const callingMn = deleteCaseType.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
